import React, { useEffect } from 'react'
import { observer } from 'mobx-react'
import SessionStore from '../State/SessionStore'
import LoadingSpinner from '../Components/LoadingSpinner'
import AuthPage from './AuthPage'
import TimesheetAppPage from './TimesheetApp/TimesheetAppPage'
import { authClient } from '../lib/auth-client'
import { Route, Switch, useLocation } from 'wouter'

export default observer(() => {
	const { data: session, isPending } = authClient.useSession()
	const [location] = useLocation()

	useEffect(() => {
		// Sync better-auth session changes with SessionStore
		const syncSession = async () => {
			if (!isPending && SessionStore.initialized) {
				if (session?.user) {
					// Session exists, update SessionStore if needed
					if (SessionStore.userId !== session.user.id) {
						await SessionStore.checkAuthentication()
					}
				} else {
					// No session, logout if needed
					if (SessionStore.authenticated) {
						await SessionStore.clearCache()
					}
				}
			}
		}

		syncSession()
	}, [session, isPending])

	// Handle loading state
	if (!SessionStore.initialized || isPending) {
		return <LoadingSpinner />
	}

	// If not authenticated and not on an auth route, redirect to login
	if (!SessionStore.authenticated && !location.startsWith('/auth')) {
		return <AuthPage authView="sign-in" />
	}

	// If authenticated but on an auth route, allow it (needed for account-details, etc.)
	if (SessionStore.authenticated && location.startsWith('/auth')) {
		// Extract the auth view from the location
		const authView = location.replace('/auth/', '')
		return <AuthPage authView={authView || 'sign-in'} />
	}

	// Authenticated users get the router
	return (
		<Switch>
			{/* Auth routes */}
			<Route path="/auth/:authView">
				{(params) => <AuthPage authView={params.authView} />}
			</Route>

			{/* Default route - Timesheet app */}
			<Route path="/">
				<TimesheetAppPage />
			</Route>

			{/* Catch-all route */}
			<Route>
				<TimesheetAppPage />
			</Route>
		</Switch>
	)
})
